export default { 
    categoria (state) {
        return state.categoria
    }
}